import { render, staticRenderFns } from "./TextSearchSetup.vue?vue&type=template&id=97a939d6&scoped=true&"
import script from "./TextSearchSetup.vue?vue&type=script&lang=js&"
export * from "./TextSearchSetup.vue?vue&type=script&lang=js&"
import style0 from "./TextSearchSetup.vue?vue&type=style&index=0&id=97a939d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a939d6",
  null
  
)

export default component.exports